import React from 'react'
import { QRCodeSVG } from 'qrcode.react'
import styles from './QRTransfer.module.css'

export default function QRTransfer({ url, code }) {
  return (
    <div className={styles.wrap}>
      <div className={styles.qrBox}>
        <QRCodeSVG value={url} size={220} />
      </div>
      {code && (
        <div className={styles.codeWrap}>
          <span className={styles.codeLabel}>Pairing code</span>
          <span className={styles.codeValue}>{code}</span>
        </div>
      )}
    </div>
  )
}
